import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';

/**
 * Asks the user to review generalised rules before a brief is activated.
 * Review is a placeholder. Skip hands control back to the activate flow.
 */
@Component({
  selector: 'app-review-questions-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './review-questions-modal.html',
  styleUrl: './review-questions-modal.scss',
})
export class ReviewQuestionsModal {
  private readonly dialog = viewChild<ElementRef<HTMLDialogElement>>('reviewDialog');

  readonly briefTitle = input.required<string>();
  readonly totalCount = input.required<number>();
  readonly generalisedCount = input.required<number>();

  readonly skipped = output<void>();
  readonly review = output<void>();

  /** Share of requirements that still need context, as a percentage of the bar. */
  readonly filledPercent = computed(() => {
    const total = this.totalCount();
    if (total <= 0) {
      return 0;
    }
    const share = (this.generalisedCount() / total) * 100;
    return Math.min(100, Math.max(0, share));
  });

  open(): void {
    const dialog = this.dialog()?.nativeElement;
    if (dialog && !dialog.open) {
      dialog.showModal();
    }
  }

  close(): void {
    this.dialog()?.nativeElement?.close();
  }

  /** Closes this dialog and hands off to the context drawer. */
  reviewQuestions(): void {
    this.close();
    this.review.emit();
  }

  skip(): void {
    this.close();
    this.skipped.emit();
  }
}
